const HEADER_PREFIX = "coupon-section-header-comms";
const FOOTER_PREFIX = "coupon-section-footer-comms";

export const COUPON_SECTION_HEADER_COMMS_DATA_TEST_ID = {
    CONTAINER: `${HEADER_PREFIX}-container`,
    IMAGE: `${HEADER_PREFIX}-image`,
    TEXT: `${HEADER_PREFIX}-text`,
};

export const COUPON_SECTION_FOOTER_COMMS_DATA_TEST_ID = {
    CONTAINER: `${FOOTER_PREFIX}-container`,
    CTA: `${FOOTER_PREFIX}-cta`,
};
